function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import api from "../api";
import environment from "../environment";
import notifications from "../notifications";
import Mapping from "../mapping/mapping";
import security from "../security";
import string from "../utils/string";
import { t } from "../translator";

var Resource = /*#__PURE__*/function () {
  function Resource() {
    var entrypoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var alias = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'common';

    _classCallCheck(this, Resource);

    _defineProperty(this, "mappings", {});

    this.alias = alias;
    this.entrypoint = entrypoint;
  }

  _createClass(Resource, [{
    key: "disableApiNotification",
    value: function disableApiNotification() {
      api.show_notifier = false;
    }
    /**
     * List a collection of resource
     *
     * @param {?object} filters
     * @param {array}   args
     *
     * @return {Promise}
     */

  }, {
    key: "list",
    value: function list(filters) {
      var _this = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return api.get.apply(api, [this.entrypoint, filters].concat(args)).then(function (_ref) {
        var data = _ref.data;
        return data;
      }).catch(function (e) {
        if (environment.dev) {
          notifications.error('Mode DEV : Error', "Unable to fetch list ".concat(_this.alias, " : ").concat(e.message));
        }

        throw e;
      });
    }
    /**
     * Create a resource item
     *
     * @param {?object} data
     * @param {array}   args
     *
     * @return {Promise}
     */

  }, {
    key: "create",
    value: function create(requestData) {
      var _this2 = this;

      requestData = this.formatRequest(requestData);

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return api.post.apply(api, [this.entrypoint, requestData].concat(args)).then(function (_ref2) {
        var data = _ref2.data;
        return data;
      }).catch(function (e) {
        if (environment.dev) {
          notifications.error('Mode DEV : Error', "Unable to create ".concat(_this2.alias, " : ").concat(e.message));
        }

        throw e;
      });
    }
    /**
     * Create a resource item
     *
     * @param {?object} data
     * @param {array}   args
     *
     * @return {Promise}
     */

  }, {
    key: "update",
    value: function update(requestData) {
      var _this3 = this;

      requestData = this.formatRequest(requestData);

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return api.put.apply(api, [this.buildUri(requestData.id), requestData].concat(args)).then(function (_ref3) {
        var data = _ref3.data;
        return data;
      }).catch(function (e) {
        if (environment.dev) {
          notifications.error('Mode DEV : Error', "Unable to update ".concat(_this3.alias, " #").concat(requestData.id, " : ").concat(e.message));
        }

        throw e;
      });
    }
    /**
     * Read a resource item
     *
     * @param {string|number} id
     * @param {array}         args
     *
     * @return {Promise}
     */

  }, {
    key: "read",
    value: function read(id) {
      var _this4 = this;

      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return api.get.apply(api, [this.buildUri(id)].concat(args)).then(function (_ref4) {
        var data = _ref4.data;
        return data;
      }).catch(function (e) {
        if (environment.dev) {
          notifications.error('Mode DEV : Error', "Unable to read ".concat(_this4.alias, " #").concat(id, " : ").concat(e.message));
        }

        throw e;
      });
    }
    /**
     * Delete a resource item
     *
     * @param {string|number|object} id
     * @param {array}                args
     *
     * @return {Promise}
     */

  }, {
    key: "delete",
    value: function _delete(id) {
      var _this5 = this;

      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      if (typeof id !== 'number' && typeof id !== 'string') {
        return this.deleteMultiple.apply(this, [id].concat(args));
      }

      return api.delete.apply(api, [this.buildUri(id)].concat(args)).catch(function (e) {
        if (environment.dev) {
          notifications.error('Mode DEV : Error', "Unable to delete ".concat(_this5.alias, " #").concat(id, " : ").concat(e.message));
        }

        throw e;
      });
    }
    /**
     * Delete a collection of resources
     * Caution : this is a custom action out of REST context
     *
     * @param {object} params
     * @param {array}  args
     *
     * @return {Promise}
     */

  }, {
    key: "deleteMultiple",
    value: function deleteMultiple(params) {
      var _this6 = this;

      params.perPage = params.id ? params.id.length : 1000;

      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      return api.get.apply(api, [this.buildUri('delete'), params].concat(args)).catch(function (e) {
        if (environment.dev) {
          notifications.error('Mode DEV : Error', "Unable to delete collection of ".concat(_this6.alias, " : ").concat(e.message));
        }

        throw e;
      });
    }
    /**
     * Fetch mapping and initialize Mapping class
     *
     * @param {string}  alias
     * @param {string}  method
     * @param {?string} uri
     *
     * @return {Promise}
     */

  }, {
    key: "fetchMapping",
    value: function fetchMapping(alias, method, uri) {
      var _this7 = this;

      if (this.mappings[alias]) {
        return Promise.resolve(this.mappings[alias]);
      }

      var uriData = ['mapping'];

      if (uri) {
        uriData.unshift(uri);
      }

      return api[method](this.buildUri.apply(this, uriData)).then(function (_ref5) {
        var data = _ref5.data;
        _this7.mappings[alias] = new Mapping(data);
        return data;
      }).catch(function (e) {
        if (environment.dev) {
          notifications.error('Mode DEV : Oops', 'Unable to fetch mapping definition');
        }

        throw e;
      });
    }
    /**
     * Get mapping instance
     *
     * @param {string} alias
     *
     * @return {?Mapping}
     */

  }, {
    key: "getMapping",
    value: function getMapping(alias) {
      return this.mappings[alias];
    }
    /**
     * Build uri of action with entrypoint
     *
     * @param {string[]} uri
     *
     * @return {string}
     */

  }, {
    key: "buildUri",
    value: function buildUri() {
      for (var _len7 = arguments.length, uri = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        uri[_key7] = arguments[_key7];
      }

      return "".concat(this.entrypoint, "/").concat(uri.join('/'));
    }
    /**
     * Can create
     *
     * @return {boolean|null}
     */

  }, {
    key: "canCreate",
    value: function canCreate() {
      return security.hasPermission(this.alias, 'create');
    }
    /**
     * Can read
     *
     * @return {boolean|null}
     */

  }, {
    key: "canRead",
    value: function canRead() {
      return security.hasPermission(this.alias, 'read');
    }
    /**
     * Can read list
     *
     * @return {boolean|null}
     */

  }, {
    key: "canReadList",
    value: function canReadList() {
      return security.hasPermission(this.alias, 'read:list');
    }
    /**
     * Can update
     *
     * @return {boolean|null}
     */

  }, {
    key: "canUpdate",
    value: function canUpdate() {
      return security.hasPermissions(_defineProperty({}, this.alias, ['read', 'update']));
    }
    /**
     * Can delete
     *
     * @return {boolean|null}
     */

  }, {
    key: "canDelete",
    value: function canDelete() {
      return security.hasPermission(this.alias, 'delete');
    }
    /**
     * Can delete multiple
     *
     * @return {boolean|null}
     */

  }, {
    key: "canDeleteMultiple",
    value: function canDeleteMultiple() {
      return security.hasPermission(this.alias, 'delete:multiple');
    }
    /**
     * Fetch property description in api
     *
     * @param {string} name
     *
     * @return {Promise}
     */

  }, {
    key: "fetchPropertyDescription",
    value: function fetchPropertyDescription(name) {
      var _this8 = this;

      return api.get(this.buildUri('property'), {
        name: name
      }).then(function (_ref6) {
        var data = _ref6.data;
        return data;
      }).catch(function () {
        notifications.error('Oops', "Unable to fetch definition of \"".concat(name, "\" for alias \"").concat(_this8.alias, "\""));
      });
    }
    /**
     * Fetch property options in api
     *
     * @param {string} name
     *
     * @return {Promise}
     */

  }, {
    key: "fetchOptions",
    value: function fetchOptions(name) {
      var _this9 = this;

      return new Promise(function (resolve) {
        _this9.fetchPropertyDescription(name).then(function (description) {
          if (description && Array.isArray(description.constraints)) {
            for (var i = 0, len = description.constraints.length; i < len; ++i) {
              if (description.constraints[i].alias === 'Choice') {
                var data = description.constraints[i].choices.map(function (value) {
                  return {
                    label: t(value),
                    value: value
                  };
                });
                resolve(data);
              }
            }
          } else {
            resolve([]);
          }
        });
      });
    }
    /**
     * Get full translation key for a property
     *
     * @param {string} propertyPath
     *
     * @return {*}
     */

  }, {
    key: "getTranslationKey",
    value: function getTranslationKey(propertyPath) {
      return string.camelCaseToSnakeCase("".concat(string.lcfirst(this.alias), ".").concat(propertyPath));
    }
    /**
     * @param {object} data
     */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "formatSubRequest",
    value: function formatSubRequest(data) {
      Object.keys(data).map(function (key) {
        if (!data[key] || _typeof(data[key]) !== 'object') {
          return true;
        }

        if (data[key]['@id']) {
          data[key] = data[key]['@id'];
        }

        return true;
      });
    }
    /**
     * Transform the sub entities as URIs.
     * @todo Check for each field the groups.
     */

  }, {
    key: "formatRequest",
    value: function formatRequest(data) {
      var _this10 = this;

      var attributesToUpdate = null;
      Object.keys(data).map(function (key) {
        // For each attribute of the entity
        if (Array.isArray(data[key])) {
          // if its an array and its childs are object with @id
          // we transform the object as a single string.
          attributesToUpdate = [];
          data[key].map(function (obj) {
            if (Array.isArray(obj)) {
              obj.map(function (element) {
                return _this10.formatSubRequest(element);
              });
              return true;
            }

            if (_typeof(obj) !== 'object') {
              return true;
            }

            if (obj['@id']) {
              attributesToUpdate.push(obj['@id']);
              return true;
            }

            obj['@id'] = null;

            _this10.formatSubRequest(obj);

            attributesToUpdate.push(obj);
            return false;
          });

          if (attributesToUpdate.length > 0) {
            data[key] = attributesToUpdate;
          }

          return true;
        }

        return false;
      });
      return data;
    }
  }]);

  return Resource;
}();

export { Resource as default };